<template>
  <div>
    <el-dialog
      title="导出任务"
      :visible.sync="excelTask"
      width="90vw"
      top="10vh"
      :before-close="handleClose"
    >
      <div class="search-wrap">
        <el-button
          class="refresh-button left-align"
          type="primary"
          size="mini"
          icon="el-icon-refresh-right"
          plain
          round
          @click="change(1)"
        >刷新
        </el-button>
        <el-descriptions :column="3" border size="mini">
          <el-descriptions-item label="搜索删除">
            <template>
              <el-radio v-model="data.isDelete" :label="0">否</el-radio>
              <el-radio v-model="data.isDelete" :label="1">是</el-radio>
            </template>
          </el-descriptions-item>
          <el-descriptions-item label="表格名称">
            <el-input size="mini" placeholder="表格名称" v-model="data.tableName" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="导出日期">
            <el-date-picker v-model="data.startDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="mini"
              style="width: 47%;"
              placeholder="开始日期"
            ></el-date-picker>
            <span class="cdj_text_data">至</span>
            <el-date-picker v-model="data.endDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="mini"
              style="width: 47%;"
              placeholder="结束日期"
            ></el-date-picker>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <el-table :data="desserts" border style="width: 100%" height="60vh">
        <el-table-column prop="id" label="ID" width="100" />
        <el-table-column prop="name" label="表格名称" width="180" />
        <el-table-column prop="create_at" label="导出日期" width="180" />
        <el-table-column label="导出状态">
          <template slot-scope="data"> {{ data.row.statusText }}</template>
        </el-table-column>
        <el-table-column label="进度">
          <template slot-scope="data">
            <span v-if="data.row.status == 2"> 申请中 </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="data">
            <el-button
              v-if="data.row.status == 1"
              type="text"
              icon="el-icon-view"
              @click="viewExcel(data.row)"
            >预览</el-button
            >
            <el-button
              v-if="data.row.status == 1"
              type="text"
              icon="el-icon-download"
              @click="downloadExcel(data.row)"
            >下载</el-button
            >
            <!-- <el-button type="text"  icon="el-icon-download"><a :href="'http://excel.gdzawy.com:9001'+data.row.url">测试下载</a></el-button> -->
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="deleteExcel(data.row.id)"
            >删除任务</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change" show-total />
      </div>
    </el-dialog>
    <ViewFile ref="ViewFile" />
  </div>
</template>

<script>
import ViewFile from "../Admin/Common/ViewFile";
import AppConfig from "../../config/AppConfig";
const imgurl = AppConfig.erp_server;
export default {
  name: "ExcelTask",
  components: {ViewFile},
  props: {
    excelTask: {
      type: Boolean,
      default: false,
    },
    excelTaskId: {
      type: Number | String,
      default: null,
    },
  },
  data() {
    return {
      desserts: [],
      total: 0,
      page: 1,
      data:{
        tableName:'',
        startDate:'',
        endDate:'',
        isDelete:0,
      },
      timer: null,
      needDownload: [],
    };
  },
  mounted() {
    // this.change(1);
  },
  watch: {
    excelTaskId(n) {
      this.needDownload.push(n);
    },
  },
  methods: {
    init() {
      this.timer = setInterval(this.change, 2000);
    },
    change(e) {
      this.$Loading.start();
      this.data.page = e > 0 ? e : 1;
      this.$myhttp
        .post("admin/ExcelTask/index", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          let clear = true; //是否清除定时器
          let data = backdata.data.data;
          this.startDate = backdata.data.startDate;
          this.endDate = backdata.data.endDate;
          this.desserts = data.data;
          this.total = data.count;
          this.page = data.pageSize;
          let id = null;
          let key = null;
          for (var item of this.desserts) {
            if (item.status == 2 || item.status == 0) {
              clear = false;
            }
            id = String(item.id);
            key = this.needDownload.indexOf(id);
            if (item.status == 1 && key !== -1) {
              this.needDownload.splice(key, 1);
              // this.viewExcel(item.url);
            }
          }
          if (clear && this.timer != null) {
            clearInterval(this.timer);
            this.timer = null;
          } else if (!clear && this.timer == null) {
            this.init();
          }
          this.$Loading.finish();
        });
    },
    handleClose() {
      if (this.timer != null) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.needDownload = [];
      this.$emit("close", false);
    },
    viewExcel(row) {
      let downloadUrl = '';
      if (row.target_controller == "ChargeSummary" ||
      row.target_controller == "CollectMoney" ||
      row.target_controller == "OweMoneyController" ||
      row.target_controller == "OweCheckController" ||
      row.target_controller == "ChargeSumController" ||
      row.target_controller == "AuditReportController") {
        // downloadUrl = "http://excel.gdzawy.com:9001" + row.url
        // downloadUrl = "https://excel.gdzawy.com:9002" + row.url
        downloadUrl = window.Glob.downloadUrl + row.url
      } else {
        downloadUrl = imgurl + row.url;
      }
      // window.open("/#/office?url="+downloadUrl, '_blank');
      // window.open("/office.html#/office?url=" + downloadUrl, "_blank");
      // window.open(downloadUrl, "_blank");

      this.$refs.ViewFile.show({
        width: '90vw',
        height:'80vh',
        title:"文件预览",
        src:downloadUrl,
        download(){
          window.open(downloadUrl)
        }
      })
    },
    downloadExcel(row) {
      let downloadUrl = '';
      if (row.target_controller == "ChargeSummary" ||
      row.target_controller == "CollectMoney" ||
      row.target_controller == "OweMoneyController" ||
      row.target_controller == "OweCheckController" ||
      row.target_controller == "ChargeSumController" ||
      row.target_controller == "AuditReportController") {
        // downloadUrl = "http://excel.gdzawy.com:9001" + row.url
        // downloadUrl = "https://excel.gdzawy.com:9002" + row.url
        downloadUrl = window.Glob.downloadUrl + row.url
      } else {
        downloadUrl = imgurl + row.url;
      }
      window.location.href = downloadUrl + "?delete=" + true;
    },
    deleteExcel(id) {
      this.$myhttp
        .post(
          "admin/ExcelTask/deleteTask",
          { id },
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.change(1);
          }
        });
    },
  },
};
</script>
<style scoped>
.left-align {
  float: left;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.refresh-button {
  margin-bottom: 2%;
}
.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}
</style>



// WEBPACK FOOTER //
// src/components/common/excelTask.vue